import BrandService from "@/store/services/brand.service.js"
import CompanyService from "@/store/services/company.service.js"

export default {
  namespaced: true,
  state: {
    availableBrands: [],
    selectedBrand: null,
    mainBrand: null,
    defaultEmptyBrand: {
      id: null,
      brand_logo: null,
      name: '',
      brand_email: '',
      brand_address: '',
      brand_postal_code: '',
      brand_city: '',
      brand_country: '',

      label_0: '',
      label_1: '',
      label_2: '',
      label_3: '',
      label_4: '',
      label_5: '',
      field_0: '',
      field_1: '',
      field_2: '',
      field_3: '',
      field_4: '',
      field_5: ''
    }
  },
  getters: {
    getAvailableBrands: state => state.availableBrands,
    getSelectedBrand: state => state.selectedBrand,
    getMainBrand: state => state.mainBrand,   //deprecated
    getBrandById: state => brand_id => state.availableBrands.find(brand => brand.id === brand_id),
    getDefaultEmptyBrand: state => state.defaultEmptyBrand,
    hasMainBrand: (state, getters, rootState) => {
      let defaultBrand = state.availableBrands.find(brand => brand.is_default)
      if (defaultBrand) {
        state.mainBrand = defaultBrand
        return defaultBrand
      }
      defaultBrand = state.availableBrands.find(brand => brand.converted_from === rootState.main.currentCompany.id && !brand.is_archived)
      if (!defaultBrand) {
        defaultBrand = state.availableBrands[0]
      }
      return defaultBrand
    }
  },
  mutations: {
    SET_AVAILABLE_BRANDS (state, data) {
      state.availableBrands = data
    },
    SET_SELECTED_BRAND (state, brand) {
      state.selectedBrand = brand
    },
    SET_MAIN_BRAND (state, brand) {
      state.mainBrand = brand
    },
    SET_CURRENT_BRAND_LOGO (state, payload) {
      state.selectedBrand.brand_logo = payload.brand_logo
    }
  },
  actions: {
    loadCompanyMainBrand ({ commit }, company_id) {
      return BrandService.getMainBrand({ company_profile: company_id }).then((response) => {
        commit('SET_MAIN_BRAND', response.data)
      })
    },
    loadCompanyBrands ({ commit }, company_id) {
      return BrandService.list({ company_profile: company_id }).then((response) => {
        commit('SET_AVAILABLE_BRANDS', response.data)
      })
    },
    loadBrandsMainData ({ dispatch }, company_id) {
      return Promise.all([
        dispatch('loadCompanyMainBrand', company_id),
        dispatch('loadCompanyBrands', company_id)
      ])
    },
    initNewBrand ({ commit, getters, rootGetters }) {
      const new_brand = getters.getDefaultEmptyBrand
      const current_company = rootGetters['main/getCurrentCompany']

      new_brand.company_profile = current_company.id,
      new_brand.created_by = rootGetters['main/getCurrentUser'].id,

      new_brand.brand_email = current_company.email
      new_brand.brand_address = current_company.address
      new_brand.brand_postal_code = current_company.postal_code
      new_brand.brand_city = current_company.city
      new_brand.brand_country = current_company.country

      new_brand.label_0 = "Phone number"
      new_brand.field_0 = current_company.phone_number

      new_brand.label_1 = "Website"
      new_brand.field_1 = current_company.website

      new_brand.label_2 = "KVK"
      new_brand.field_2 = current_company.kvk

      new_brand.label_3 = "BTW"
      new_brand.field_3 = current_company.btw

      new_brand.label_4 = "Bank Account Number"
      new_brand.field_4 = current_company.bank_account_number
      
      new_brand.label_5 = "Swift Number"
      new_brand.field_5 = current_company.companysettings.swift_number

      commit('SET_SELECTED_BRAND', new_brand)
    },
    copyToBrand ({ dispatch, commit, getters, rootGetters }) {
      return CompanyService.copyToBrand().then((response) => {

        // refresh brands data and set selected the new created brand
        dispatch('loadBrandsMainData', rootGetters['main/getCurrentCompany'].id).then(() => {
          const new_brand = getters.getBrandById(response.data.id)
          commit('SET_SELECTED_BRAND', new_brand)
        })

      })
    },
    uploadBrandLogo ({ commit }, payload) {
      console.log('brands::updateBrandLogo()', payload)
      const data = { file: payload.brand_logo }
      return BrandService.uploadLogo(payload.id, data).then((response) => {
        commit('SET_CURRENT_BRAND_LOGO', { brand_logo: response.data.brand_logo })
      })
    },
    deleteBrandLogo ({ commit }, brand_id) {
      console.log('brands::deleteBrandLogo()', brand_id)
      return BrandService.deleteLogo(brand_id).then(() => {
        commit('SET_CURRENT_BRAND_LOGO', { brand_logo: null })
      })
    },
    getBrandDataAndSelect ({ commit }, brand_id) {
      return BrandService.retrieve(brand_id).then((response) => {
        commit('SET_SELECTED_BRAND', response.data)
      })
    },
  }
};